import { mergeProps as _mergeProps, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
export default {
  name: 'VipIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return _createVNode("svg", _mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-vip",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [_createTextVNode("   "), _createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M3 5h18"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M3 19h18"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M4 9l2 6h1l2 -6"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M12 9v6"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M16 15v-6h2a2 2 0 1 1 0 4h-2"
    }, null), _createTextVNode(" ")]);
  }
};